import "./index.css";

import { useEffect, useMemo } from "react";
import { RouterProvider } from "@tanstack/react-router";
import { useAtomValue } from "jotai";
import { pdfjs } from "react-pdf";

import { routerInstance } from "@/utils/router";

import { userCurrentCampusId, userRoleAtom } from "./stores/atoms";
import {
  setupAuthListener,
  useCurrentUserId,
  useCurrentUserType,
  useIsAuthenticated,
} from "./stores/authStore";

// Served from apps/web/public/pdf-worker/ at the site root. Must be an
// absolute path: a relative one resolves against the current route and 404s
// (which the SPA rewrite turns into index.html, breaking the module worker).
// Keep the file in sync with the pdfjs-dist version react-pdf depends on.
pdfjs.GlobalWorkerOptions.workerSrc = "/pdf-worker/pdf.worker.min.js";

export const App = () => {
  const isAuthenticated = useIsAuthenticated();

  const userId = useCurrentUserId();

  const userRole = useAtomValue(userRoleAtom);

  const userType = useCurrentUserType();

  const currentCampusId = useAtomValue(userCurrentCampusId);

  useEffect(() => {
    const authSubscription = setupAuthListener();

    return () => {
      authSubscription.unsubscribe();
    };
  }, []);

  const store = useMemo(
    () => ({
      isAuthenticated,
      userType,
      userRole,
      userId,
      currentCampusId,
    }),
    [isAuthenticated, userType, userRole, currentCampusId, userId],
  );

  if (isAuthenticated === undefined) {
    return null;
  }

  return <RouterProvider router={routerInstance} context={store} />;
};
